// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__3bE6p","point":"classes_point__2RBuT"};